'use client'

import { Locale, getDictionary } from '@/app/[lang]/dictionaries'
import { usePathname } from 'next/navigation'
import { createContext, useContext, useEffect, useState } from 'react'

type DictionaryContextType = {
  dictionary: Dictionary
  locale: Locale
}

export const DictionaryContext = createContext<DictionaryContextType | null>(null)

export const DictionaryProvider = ({ children }: { children: React.ReactNode }) => {
  const [dictionaryData, setDictionaryData] = useState<DictionaryContextType | null>(null)
  const pathname = usePathname()

  useEffect(() => {
    const loadDictionary = async () => {
      // Get locale from the first part of the path after /
      const locale = pathname?.split('/')[1] as Locale
      if (locale) {
        const dictionary = await getDictionary(locale)
        setDictionaryData({ dictionary, locale })
      }
    }

    loadDictionary()
  }, [pathname])

  if (!dictionaryData) {
    return null // or a loading spinner
  }

  return <DictionaryContext.Provider value={dictionaryData}>{children}</DictionaryContext.Provider>
}

export const useDictionary = () => {
  const context = useContext(DictionaryContext)
  if (context === null) {
    throw new Error('useDictionary must be used within a DictionaryProvider')
  }
  return context
}
